export const YELLOW_GLOW_BOX_SHADOW = "0px 0px 5px 2px rgba(255,217,0,0.9)";
export const GRAY_GLOW_BOX_SHADOW = "0px 0px 15px 5px rgba(128,128,128,0.9)";
